import { render, staticRenderFns } from "./AddPost.vue?vue&type=template&id=747ec8d1&"
import script from "./AddPost.vue?vue&type=script&lang=js&"
export * from "./AddPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports